module.exports = __webpack_public_path__ + "static/media/FundScreener.6b6096e8.mp4";